<template>
	<div v-if="show">
		<span class="input-label" :id="data.labelId">{{ dateTitle }}<span class="input__wrapper-mandatory" v-if="data.mandatoryFiled">*</span></span>
		<div class="date-input">
			<span class="input-icon-box">
				<SvgIcon class="calendar-icon" iconName="ico-calendar"/>
			</span>
			<datepicker
				:placeholder="placeholder"
				format="MM/dd/yyyy"
				v-model="inputVal"
				@selected="dateSelected($event, data.flag)"
				:id="data.inputId"
			/>
			<span class="input-icon-delete-date" v-if="hasValue" @click="resetDate()">
				<SvgIcon iconName="ico-close-icon"/>
			</span>
		</div>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		placeholder: {
			type: String,
			default: 'Date'
		},
		disabledDates: {},
		dateTitle: {
			type: String
		},
		show: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			hasValue: false,
			inputVal: this.data.today ? this.data.today : this.value
		};
	},
	watch: {
		inputVal (val) {
			this.$emit('input', val);
			this.hasValue = !!val;
		}
	},
	mounted() {
		if (this.inputVal !== '') {
			this.hasValue = false;
		}
	},
	components: {
		Datepicker,
		SvgIcon
	},

	methods: {
		dateSelected (e, flag) {
			this.$emit('changeVal', e, flag);
		},
		setValue(value) {
			this.inputVal = value;
		},
		resetDate() {
			this.inputVal = '';
			this.hasValue = false;
			this.setValue('');
		}
	}
};
</script>

<style lang="scss" scoped>
.data-input-container {
	display: flex;
	flex-wrap: wrap;
}
.date-input {
    display: flex;
	position: relative;
	margin-bottom: 27px;
	background-color: $white-lilac;

	input {
		background-color: $white-lilac;
	}

	@include mq($lg) {
		margin-bottom: 20px;
	}

	@include mq(500px) {
		max-width: 100%;
	}
}

.input-icon-delete-date {
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
	cursor: pointer;
}

.date-input__inner::-webkit-inner-spin-button,
.date-input__inner::-webkit-calendar-picker-indicator {
	width: 100%;
	position: absolute;
	height: 100%;
	top: 0;
	left: 25px;
	border: 1px solid $red;
	max-width: 240px;
	opacity: 0;
	cursor: pointer;
}

.input-label {
    margin-bottom: 5px;
}

.date-input__inner {
	max-width: 250px;
	display: block;
	border: 1px solid $grey-light;
	padding: 15px 20px;
	line-height: 1.2;
	width: 100%;
	font-size: 14px;
	font-family: $font-main;
	color: $fiord;
    transition: $dur $ease;

	@include mq($sm) {
		font-size: 16px;
		padding: 13px;
	}

    &:focus {
        border: 1px solid $dodger-blue; 
    }

	@include placeholder {
		color: $grey;
	}
}

.input-icon-box {
    background-color: $white-lilac;
	min-height: 46px;
    min-width: 47px;
    display: block;
	pointer-events: none;
	z-index: 1;
	position: relative;
	border-bottom-left-radius: 8px;
	border-top-left-radius: 8px;
}

.input-icon-box-icon {
	color: $black;
	font-size: 14px;
	z-index: 2;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	position: absolute;
}

input[type='date'] {
	color: rgba(66, 82, 110, 0.5);
}
</style>
